import { useLocalObservable } from "mobx-react";
import React, { createContext, ReactNode, useEffect, useMemo, useState } from "react";

import { UserProfileApi, Configuration } from "../../api-client";
import UserStore from "./UserStore";
import useStore from "../../helpers/useStore";
import { AuthContext } from "../Auth/auth.provider";
import { observer } from "mobx-react";

interface UserProviderProps {
  children: ReactNode;
}

export const UserContext = createContext<UserStore | null>(null);
UserContext.displayName = "UserContext";

export const UserProvider = observer(({ children }: UserProviderProps) => {
  const basePath = process.env.REACT_APP_API_URL;
  const AuthenticationStore = useStore(AuthContext);
  const { authToken } = AuthenticationStore;

  // const config = new Configuration({
  //   basePath: basePath,
  //   accessToken: authToken || "",
  // });

  // // console.log("User Provider has token:", authToken);
  // const apiClient = new UserProfileApi(config);

  const apiConfig = useMemo(
    () => new Configuration({ basePath, accessToken: authToken ?? "" }),
  [basePath, authToken]);
  const apiClient = useMemo(() => new UserProfileApi(apiConfig), [apiConfig]);

  // const store = new UserStore(apiClient, AuthenticationStore);
  const [store] = useState(() => new UserStore(apiClient, AuthenticationStore));

  store.apiClient = apiClient;

  useEffect(() => {
  store.apiClient = apiClient; // update dependency when token changes
  }, [apiClient, store]);

  useEffect(() => {
    if (authToken) void store.getUser(); // side-effect, not in render
  }, [authToken, store]);


  return <UserContext.Provider value={store}>{children}</UserContext.Provider>;
});
